var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"addTables"},[_c('currencyTable',{ref:"addTables",attrs:{"table-data":_vm.tableData}},[_c('div',{staticClass:"btns",attrs:{"slot":"buttons"},slot:"buttons"},[_c('el-button',{attrs:{"size":"mini"},on:{"click":_vm.confirmSelection}},[_vm._v(" 确认选择 ")])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }